export default __webpack_public_path__ + "static/media/psactions.36457299.txt";